import { render, staticRenderFns } from "./ManualInstructivo.vue?vue&type=template&id=459fb808&scoped=true&"
import script from "./ManualInstructivo.vue?vue&type=script&lang=js&"
export * from "./ManualInstructivo.vue?vue&type=script&lang=js&"
import style0 from "./ManualInstructivo.vue?vue&type=style&index=0&id=459fb808&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459fb808",
  null
  
)

export default component.exports